"use strict";

const $ = require("jquery");
const popupControl = require("js/controls/popup_control.js");
const events = require("js/event_helper");

import { SEARCH_HORIZON } from "js/card_search.js";

const SEARCH_BAR_ID = "card-search-top-bar";
const SEARCH_POPUP_ID = "#popup-search-card";

let popup = null;
let userChoice = $.Deferred();

function init() {
    if (popup == null) {
        popup = document.querySelector("#popup-search-card-container");

        if (popup) {
            // double click on a single row
            popup.addEventListener("card-search-show", (e) => {
                __resolve({
                    id: e.detail.instanceId,
                    title: e.detail.cardTitle,
                });
            });
        }
    }
}

function show(opts = {}) {
    userChoice.reject();
    userChoice = $.Deferred();

    if (popup.querySelector("#" + SEARCH_BAR_ID) == null) {
        addTopBarAndCloseButtonsToPopup();
    }

    events.dispatch(SEARCH_HORIZON, popup.querySelector(SEARCH_POPUP_ID), opts);

    popupControl.show(popup, popup.querySelector("ldc-filter-default#__permanent_all"), { useLiveViewContainer: true });
    popup.querySelector(SEARCH_POPUP_ID).classList.remove("disabled");

    return userChoice.then((selectedCards) => {
        hide;
        return selectedCards;
    });
}

function hide() {
    // we need the null guard because some code might try to close the popup on init, before
    // the popup itself has been initialised (which only happens after page load).
    if (popup != null) {
        popupControl.hide();
        popup.querySelector(SEARCH_POPUP_ID).classList.add("disabled");
    }
}

function __getSearchResult() {
    return popup.querySelector("ldc-card-search-result");
}

function __resolve(selectedCards) {
    const result = Array.isArray(selectedCards) ? selectedCards : [selectedCards];
    userChoice.resolve(result);
    hide();
}

/**
 * reverse engineering notes by Kiru: This whole file was created by Dian and should be refactored one day.
 * I renamed a few functions to understand what's going on.
 */
function addTopBarAndCloseButtonsToPopup() {
    let closeButton = document.createElement("i");
    closeButton.classList.add("fa");
    closeButton.classList.add("fa-times");
    closeButton.classList.add("fa-lg");
    closeButton.classList.add("clickable");

    closeButton.addEventListener("click", hide);

    let topStretcher = document.createElement("div");
    topStretcher.classList.add("stretch");

    let topBar = document.createElement("div");
    topBar.id = SEARCH_BAR_ID;
    topBar.classList.add("hbox");
    topBar.appendChild(topStretcher);
    topBar.appendChild(closeButton);

    popup.insertBefore(topBar, popup.firstChild);

    let cancelBtn = document.createElement("button");
    cancelBtn.type = "button";
    cancelBtn.innerHTML = "cancel";
    cancelBtn.style.margin = "3px";
    cancelBtn.classList.add("btn", "btn-default", "btn-xs");
    cancelBtn.setAttribute("id", "cancel");

    let okBtn = document.createElement("button");
    okBtn.type = "button";
    okBtn.innerHTML = "ok";
    okBtn.style.margin = "3px";
    okBtn.classList.add("btn", "btn-primary", "btn-xs");
    okBtn.setAttribute("id", "ok");

    let buttonDiv = document.createElement("div");
    buttonDiv.classList.add("button-div");
    buttonDiv.appendChild(cancelBtn);
    buttonDiv.appendChild(okBtn);

    popup.appendChild(buttonDiv);

    cancelBtn.addEventListener("click", (e) => {
        hide();
    });

    okBtn.addEventListener("click", (e) => {
        __resolve(__getSearchResult().getSelectedCards());
    });

    /**
     * This was .click before, but .click() captures mouse-up events (e.g you click inside the modal popup and release outside)
     */
    $(document).on("mousedown", function (event) {
        if (event.target.classList.contains("modal-container")) {
            hide();
        }
    });

    /**
     * this global keydown listener is breaking some code otherwise. I added a few log statements track it down, but
     * generally we should get rid of this in the long run.
     */
    document.addEventListener("keydown", function (event) {
        if (event.key == "Escape") {
            console.log("hide popup because escape has been pressed");
            hide();
        } else if (event.key === "Enter") {
            const searchResult = __getSearchResult();
            if (searchResult != null && searchResult.checkVisibility()) {
                let selected = __getSearchResult().getSelectedCards();
                if (selected.length == 0) {
                    console.log("hide popup because nothing is selected");
                    hide();
                } else {
                    console.log("Some card sare selected, call resolve");
                    __resolve(selected);
                }
            }
        }
    });
}

module.exports.init = init;
module.exports.show = show;
module.exports.hide = hide;
